import H5PreApiMonitor from './H5PreApiMonitor';
import Request from './request';
import utils from './utils';

const pageId = utils.getPageId();
const preApiMonitor = new H5PreApiMonitor(`zt-public.shihuo.cn/page/${pageId}/index.html`);

// 清单横画组件数据接口前置封装
const fetchH5PreApiRequestData = async({url, method = 'get', params, isH5PreApi} = {}) => {
  if (!isH5PreApi) {
    const { data } = await fetchH5RequestData({url, method, params});
    return data;
  }
  return new Promise((resolve, reject) => {
  preApiMonitor.getPreData(() => fetchH5RequestData({url, method, params}), url, '').then(successData => {
    const { status, data, msg } = successData
    if (status == 0) {
      resolve(data)
    } else {
      reject({
        code: status,
        msg
      })
    }
  }).catch(error => {
      reject(error)
    })
  })
}

// 清单横画组件数据接口API获取数据
const fetchH5RequestData = ({url, method = 'post', params} = {}) => {
  return new Promise((resolve, reject) => {
    Request({
      url,
      method,
      withCredentials: true,
      data: params
    }).then((res) => {
      resolve(res.data)
    }).catch(() => {
      resolve({});
    });
  });
}

export default fetchH5PreApiRequestData;


// WEBPACK FOOTER //
// ./utils/H5PreApiFetch.js